/////////////////////////////////////////////////////////////////////
// Copyright (c) Autodesk, Inc. All rights reserved
/////////////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////////////////////to działa
/*import React, { Component } from 'react';
import Script from 'react-load-script';
import { connect } from 'react-redux';
import { getActiveProject } from '../reducers/mainReducer';
import './forgeView.css';
import Message from './message';
import repo from '../Repository';
import { viewerCss, viewerJs } from './shared';

let Autodesk = null;

const norm = (s) =>
    (s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();

function buildLeafBom(viewer) {
    return new Promise((resolve, reject) => {
        try {
            viewer.getObjectTree(async (tree) => {
                if (!tree) return reject(new Error('no tree'));

                // 1) liście
                const leaves = [];
                (function walk(id) {
                    let hasChild = false;
                    tree.enumNodeChildren(id, (cid) => {
                        hasChild = true;
                        walk(cid);
                    });
                    if (!hasChild) leaves.push(id);
                })(tree.getRootId());

                // 2) zbierz właściwości masowo: liście + wszyscy przodkowie
                const candidateIds = new Set();
                for (const leaf of leaves) {
                    let cur = leaf;
                    while (cur !== -1 && cur != null) {
                        candidateIds.add(cur);
                        const parent = tree.getNodeParentId(cur);
                        if (parent === cur) break;
                        cur = parent;
                    }
                }

                const propsAll = await new Promise((res, rej) =>
                    viewer.model.getBulkProperties([...candidateIds], null, res, rej)
                );
                const propsMap = new Map(propsAll.map((r) => [r.dbId, r.properties || []]));

                const norm = (s) =>
                    (s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();

                const pick = (propsArr, aliases) => {
                    const set = new Set(aliases.map(norm));
                    for (const p of propsArr || []) {
                        const name = norm(p.displayName || p.attributeName || p.name || '');
                        if (set.has(name)) return p.displayValue ?? p.value ?? '';
                    }
                    return '';
                };

                const pnAliases = ['part number', 'partnumber', 'numer części', 'numer czesci', 'pn', 'number'];
                const descAliases = ['description', 'opis', 'opis elementu', 'opis komponentu'];
                const matAliases = ['material', 'materiał', 'material name', 'nazwa materiału', 'nazwa materialu'];
                const isIso10642 = /^iso\s*10642\b/i;

                // znajdź pierwszy przodek z PN
                const findOccWithPn = (startId) => {
                    let cur = startId;
                    while (cur !== -1 && cur != null) {
                        const pn = pick(propsMap.get(cur) || [], pnAliases);
                        if (pn) return cur;
                        const parent = tree.getNodeParentId(cur);
                        if (parent === cur) break;
                        cur = parent;
                    }
                    return startId;
                };

                const countedOcc = new Set();       // KLUCZOWE: zliczamy occurrence tylko raz
                const grouped = new Map();       // pn -> { pn, qty, desc, mat }

                for (const leaf of leaves) {
                    const occ = findOccWithPn(leaf);
                    if (countedOcc.has(occ)) continue;  // ← zapobiega "21" dla jednego Stołu
                    countedOcc.add(occ);

                    const propsOcc = propsMap.get(occ) || [];
                    const propsLeaf = propsMap.get(leaf) || [];

                    let pn = pick(propsOcc, pnAliases);
                    let ds = pick(propsOcc, descAliases) || pick(propsLeaf, descAliases);
                    let mt = pick(propsLeaf, matAliases) || pick(propsOcc, matAliases);

                    if (!pn) {
                        // awaryjnie nazwa węzła
                        pn = viewer.model?.getInstanceTree()?.getNodeName?.(occ)
                            || viewer.model?.getInstanceTree()?.getNodeName?.(leaf)
                            || `#${leaf}`;
                    }

                    if ((!mt || !String(mt).trim()) && !isIso10642.test(pn)) {
                        mt = 'Drewno (brzoza)'; // domyślny materiał jak w demie
                    }

                    const row = grouped.get(pn) || { pn, qty: 0, desc: '', mat: '' };
                    row.qty += 1;                // liczymy wystąpienia zespołu/części, nie liście
                    if (!row.desc && ds) row.desc = ds;
                    if (!row.mat && mt) row.mat = mt;
                    grouped.set(pn, row);
                }

                const rows = Array.from(grouped.values())
                    .sort((a, b) => a.pn.localeCompare(b.pn, 'pl', { numeric: true, sensitivity: 'base' }))
                    .map((r, i) => ({ row: i + 1, pn: r.pn, qty: r.qty, desc: r.desc, mat: r.mat }));

                resolve(rows);
            });
        } catch (e) {
            reject(e);
        }
    });
}


export class ForgeView extends Component {
    constructor(props) {
        super(props);
        this.viewerDiv = React.createRef();
        this.viewer = null;
    }

    handleScriptLoad() {
        const options = repo.hasAccessToken()
            ? { accessToken: repo.getAccessToken() }
            : { env: 'Local' };

        Autodesk = window.Autodesk;

        const container = this.viewerDiv.current;
        this.viewer = new Autodesk.Viewing.GuiViewer3D(container);

        Autodesk.Viewing.Initializer(options, this.handleViewerInit.bind(this));
    }

    handleViewerInit() {
        const errorCode = this.viewer.start();
        if (errorCode) return;

        // udostępnij viewer globalnie i powiadom, że działa
        window._forgeViewer = this.viewer;
        window.dispatchEvent(
            new CustomEvent('forge-viewer-ready', { detail: { viewer: this.viewer } })
        );

        // Po załadowaniu geometrii zrób snapshot BOM i powiadom BOM
        this.viewer.addEventListener(Autodesk.Viewing.GEOMETRY_LOADED_EVENT, async () => {
            try {
                const rows = await buildLeafBom(this.viewer);
                window._bomFromViewer = rows;
                window.dispatchEvent(
                    new CustomEvent('bom-from-viewer-ready', { detail: { rows } })
                );
            } catch (e) {
                // nic — spróbujemy jeszcze po loadDocumentNode resolve
                // (lub BOM sam się dosłucha kolejnego GEOMETRY_LOADED)
            }
        });

        // załaduj model jeśli jest
        if (!this.props.activeProject.svf) return;

        Autodesk.Viewing.Document.load(
            this.getSvfUrl(),
            this.onDocumentLoadSuccess.bind(this),
            (e) => console.warn('Document.load error', e)
        );
    }

    componentDidUpdate(prevProps) {
        if (Autodesk && this.props.activeProject.svf !== prevProps.activeProject.svf) {
            Autodesk.Viewing.Document.load(
                this.getSvfUrl(),
                this.onDocumentLoadSuccess.bind(this),
                (e) => console.warn('Document.load error', e)
            );
        }
    }

    componentWillUnmount() {
        if (this.viewer) {
            try {
                this.viewer.finish();
                Autodesk.Viewing.shutdown();
            } catch { }
            this.viewer = null;
            delete window._forgeViewer;
        }
    }

    getSvfUrl() {
        return this.props.activeProject.svf + `/bubble.json`;
    }

    onDocumentLoadSuccess(viewerDocument) {buildLeafBom
        const defaultModel = viewerDocument.getRoot().getDefaultGeometry();
        this.viewer
            .loadDocumentNode(viewerDocument, defaultModel)
            .then(async () => {
                // dodatkowa próba zbudowania BOM od razu po wczytaniu (na wypadek, gdyby GEOMETRY_LOADED już „przeleciało”)
                try {
                    const rows = await buildLeafBom(this.viewer);
                    window._bomFromViewer = rows;
                    window.dispatchEvent(
                        new CustomEvent('bom-from-viewer-ready', { detail: { rows } })
                    );
                } catch (e) {
                    // poczekamy na GEOMETRY_LOADED_EVENT
                }
            })
            .catch((err) => console.error('[ForgeView] Failed to load model:', err));
    }

    render() {
        return (
            <div className="modelContainer fullheight">
                <Message />
                <div className="viewer" id="AutodeskViewer">
                    <div ref={this.viewerDiv}></div>
                    <link rel="stylesheet" type="text/css" href={viewerCss} />
                    <Script url={viewerJs} onLoad={this.handleScriptLoad.bind(this)} />
                </div>
            </div>
        );
    }
}

export default connect((store) => ({ activeProject: getActiveProject(store) }))(
    ForgeView
);
*/


/*/////////////////////////////////////////////////////////////////////
// Copyright (c) Autodesk, Inc. All rights reserved
/////////////////////////////////////////////////////////////////////

import React, { Component } from 'react';
import Script from 'react-load-script';
import { connect } from 'react-redux';
import { getActiveProject } from '../reducers/mainReducer';
import './forgeView.css';
import Message from './message';
import repo from '../Repository';
import { viewerCss, viewerJs } from './shared';

let Autodesk = null;

// bazowa normalizacja
const norm = (s) =>
    (s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();

// pełne „spłaszczenie” PL (ł->l itd.)
const latinize = (s) =>
    (s || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()
        .replace(/ł/g, 'l')
        .replace(/ą/g, 'a')
        .replace(/ć/g, 'c')
        .replace(/ę/g, 'e')
        .replace(/ń/g, 'n')
        .replace(/ó/g, 'o')
        .replace(/ś/g, 's')
        .replace(/ż/g, 'z')
        .replace(/ź/g, 'z');

// -------------------------
//  BOM (płaska lista)
// -------------------------
function buildLeafBom(viewer) {
    return new Promise((resolve, reject) => {
        try {
            viewer.getObjectTree(async (tree) => {
                if (!tree) return reject(new Error('no tree'));

                // 1) liście
                const leaves = [];
                (function walk(id) {
                    let hasChild = false;
                    tree.enumNodeChildren(id, (cid) => {
                        hasChild = true;
                        walk(cid);
                    });
                    if (!hasChild) leaves.push(id);
                })(tree.getRootId());

                // 2) zbierz właściwości masowo: liście + wszyscy przodkowie
                const candidateIds = new Set();
                for (const leaf of leaves) {
                    let cur = leaf;
                    while (cur !== -1 && cur != null) {
                        candidateIds.add(cur);
                        const parent = tree.getNodeParentId(cur);
                        if (parent === cur) break;
                        cur = parent;
                    }
                }

                const propsAll = await new Promise((res, rej) =>
                    viewer.model.getBulkProperties([...candidateIds], null, res, rej)
                );
                const propsMap = new Map(propsAll.map((r) => [r.dbId, r.properties || []]));

                const pick = (propsArr, aliases) => {
                    const set = new Set(aliases.map(norm));
                    for (const p of propsArr || []) {
                        const name = norm(p.displayName || p.attributeName || p.name || '');
                        if (set.has(name)) return p.displayValue ?? p.value ?? '';
                    }
                    return '';
                };

                const pnAliases = ['part number', 'partnumber', 'numer części', 'numer czesci', 'pn', 'number'];
                const descAliases = ['description', 'opis', 'opis elementu', 'opis komponentu'];
                const matAliases = ['material', 'materiał', 'material name', 'nazwa materiału', 'nazwa materialu'];
                const isIso10642 = /^iso\s*10642\b/i;

                // znajdź pierwszy przodek z PN
                const findOccWithPn = (startId) => {
                    let cur = startId;
                    while (cur !== -1 && cur != null) {
                        const pn = pick(propsMap.get(cur) || [], pnAliases);
                        if (pn) return cur;
                        const parent = tree.getNodeParentId(cur);
                        if (parent === cur) break;
                        cur = parent;
                    }
                    return startId;
                };

                const countedOcc = new Set(); // zliczamy occurrence tylko raz
                const grouped = new Map(); // pn -> { pn, qty, desc, mat }

                for (const leaf of leaves) {
                    const occ = findOccWithPn(leaf);
                    if (countedOcc.has(occ)) continue;
                    countedOcc.add(occ);

                    const propsOcc = propsMap.get(occ) || [];
                    const propsLeaf = propsMap.get(leaf) || [];

                    let pn = pick(propsOcc, pnAliases);
                    let ds = pick(propsOcc, descAliases) || pick(propsLeaf, descAliases);
                    let mt = pick(propsLeaf, matAliases) || pick(propsOcc, matAliases);

                    if (!pn) {
                        // awaryjnie nazwa węzła
                        pn =
                            viewer.model?.getInstanceTree()?.getNodeName?.(occ) ||
                            viewer.model?.getInstanceTree()?.getNodeName?.(leaf) ||
                            `#${leaf}`;
                    }

                    if ((!mt || !String(mt).trim()) && !isIso10642.test(pn)) {
                        mt = 'Drewno (brzoza)';
                    }

                    const row = grouped.get(pn) || { pn, qty: 0, desc: '', mat: '' };
                    row.qty += 1; // liczymy wystąpienia zespołu/części, nie liście
                    if (!row.desc && ds) row.desc = ds;
                    if (!row.mat && mt) row.mat = mt;
                    grouped.set(pn, row);
                }

                const rows = Array.from(grouped.values())
                    .sort((a, b) => a.pn.localeCompare(b.pn, 'pl', { numeric: true, sensitivity: 'base' }))
                    .map((r, i) => ({ row: i + 1, pn: r.pn, qty: r.qty, desc: r.desc, mat: r.mat }));

                resolve(rows);
            });
        } catch (e) {
            reject(e);
        }
    });
}

// -------------------------
//  LICZENIE TOP-LEVEL ASM
// -------------------------
async function computeTopAssemblyCounts(viewer) {
    return new Promise((resolve) => {
        viewer.getObjectTree((tree) => {
            let rootId = tree.getRootId();

            // jeśli root jest "opakowany" (np. "Złożenie ×1"), zejdź o 1 poziom
            const tmpChildren = [];
            tree.enumNodeChildren(rootId, (cid) => tmpChildren.push(cid));
            if (tmpChildren.length === 1) {
                rootId = tmpChildren[0];
            }

            const tables = [];
            const benches = [];
            const chairs = [];

            tree.enumNodeChildren(rootId, (cid) => {
                const name = latinize(tree.getNodeName(cid) || '');
                // prefiksy/odmiany nazw
                if (name.includes('stol')) {
                    tables.push(cid);
                } else if (name.includes('lawka')) {
                    benches.push(cid);
                } else if (name.includes('fotel') || name.includes('krzeslo')) {
                    chairs.push(cid);
                }
            });

            resolve({ tables, benches, chairs });
        });
    });
}

export class ForgeView extends Component {
    constructor(props) {
        super(props);
        this.viewerDiv = React.createRef();
        this.viewer = null;
    }

    handleScriptLoad() {
        const options = repo.hasAccessToken() ? { accessToken: repo.getAccessToken() } : { env: 'Local' };

        Autodesk = window.Autodesk;

        const container = this.viewerDiv.current;
        this.viewer = new Autodesk.Viewing.GuiViewer3D(container);

        Autodesk.Viewing.Initializer(options, this.handleViewerInit.bind(this));
    }

    async handleViewerInit() {
        const errorCode = this.viewer.start();
        if (errorCode) return;

        // udostępnij viewer globalnie i powiadom, że działa
        window._forgeViewer = this.viewer;
        window.dispatchEvent(new CustomEvent('forge-viewer-ready', { detail: { viewer: this.viewer } }));

        const doSnapshot = async () => {
            try {
                // Płaska lista BOM do starego mechanizmu:
                const rows = await buildLeafBom(this.viewer);
                window._bomFromViewer = rows;
                window.dispatchEvent(new CustomEvent('bom-from-viewer-ready', { detail: { rows } }));

                // Nowe: liczenie liczby stołów/ławek/krzeseł
                const counts = await computeTopAssemblyCounts(this.viewer);
                window._asmCounts = counts; // { tables:number[], benches:number[], chairs:number[] }
                window.dispatchEvent(new CustomEvent('assembly-counts-ready', { detail: counts }));
            } catch (e) {
                // pominięte – spróbujemy przy kolejnym evencie
            }
        };

        // Po załadowaniu geometrii – snapshoty
        this.viewer.addEventListener(Autodesk.Viewing.GEOMETRY_LOADED_EVENT, doSnapshot);

        // załaduj model jeśli jest
        if (!this.props.activeProject.svf) return;

        Autodesk.Viewing.Document.load(
            this.getSvfUrl(),
            async (doc) => {
                const defaultModel = doc.getRoot().getDefaultGeometry();
                try {
                    await this.viewer.loadDocumentNode(doc, defaultModel);
                    // dodatkowa próba (gdyby GEOMETRY_LOADED już „mignęło”)
                    await doSnapshot();
                } catch (err) {
                    console.error('[ForgeView] Failed to load model:', err);
                }
            },
            (e) => console.warn('Document.load error', e)
        );
    }

    componentDidUpdate(prevProps) {
        if (Autodesk && this.props.activeProject.svf !== prevProps.activeProject.svf) {
            Autodesk.Viewing.Document.load(
                this.getSvfUrl(),
                async (doc) => {
                    const defaultModel = doc.getRoot().getDefaultGeometry();
                    try {
                        await this.viewer.loadDocumentNode(doc, defaultModel);

                        const rows = await buildLeafBom(this.viewer);
                        window._bomFromViewer = rows;
                        window.dispatchEvent(new CustomEvent('bom-from-viewer-ready', { detail: { rows } }));

                        const counts = await computeTopAssemblyCounts(this.viewer);
                        window._asmCounts = counts;
                        window.dispatchEvent(new CustomEvent('assembly-counts-ready', { detail: counts }));
                    } catch (err) {
                        console.error('[ForgeView] Failed to load model:', err);
                    }
                },
                (e) => console.warn('Document.load error', e)
            );
        }
    }

    componentWillUnmount() {
        if (this.viewer) {
            try {
                this.viewer.finish();
                Autodesk.Viewing.shutdown();
            } catch { }
            this.viewer = null;
            delete window._forgeViewer;
        }
    }

    getSvfUrl() {
        return this.props.activeProject.svf + `/bubble.json`;
    }

    render() {
        return (
            <div className="modelContainer fullheight">
                <Message />
                <div className="viewer" id="AutodeskViewer">
                    <div ref={this.viewerDiv}></div>
                    <link rel="stylesheet" type="text/css" href={viewerCss} />
                    <Script url={viewerJs} onLoad={this.handleScriptLoad.bind(this)} />
                </div>
            </div>
        );
    }
}

*//* istanbul ignore next *//*
export default connect((store) => ({ activeProject: getActiveProject(store) }))(ForgeView);
*/



/////////////////////////////////////////////////////////////////////
// Copyright (c) Autodesk, Inc. All rights reserved
/////////////////////////////////////////////////////////////////////

import React, { Component } from 'react';
import Script from 'react-load-script';
import { connect } from 'react-redux';
import { getActiveProject } from '../reducers/mainReducer';
import './forgeView.css';
import Message from './message';
import repo from '../Repository';
import { viewerCss, viewerJs } from './shared';

let Autodesk = null;

// bazowa normalizacja
const norm = (s) =>
    (s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();

// pełne „spłaszczenie” PL (ł->l itd.)
const latinize = (s) =>
    (s || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()
        .replace(/ł/g, 'l')
        .replace(/ą/g, 'a')
        .replace(/ć/g, 'c')
        .replace(/ę/g, 'e')
        .replace(/ń/g, 'n')
        .replace(/ó/g, 'o')
        .replace(/ś/g, 's')
        .replace(/ż/g, 'z')
        .replace(/ź/g, 'z');

// -------------------------
//  BOM (płaska lista)
// -------------------------
function buildLeafBom(viewer) {
    return new Promise((resolve, reject) => {
        try {
            viewer.getObjectTree(async (tree) => {
                if (!tree) return reject(new Error('no tree'));

                // 1) liście
                const leaves = [];
                (function walk(id) {
                    let hasChild = false;
                    tree.enumNodeChildren(id, (cid) => {
                        hasChild = true;
                        walk(cid);
                    });
                    if (!hasChild) leaves.push(id);
                })(tree.getRootId());

                // 2) zbierz właściwości masowo: liście + wszyscy przodkowie
                const candidateIds = new Set();
                for (const leaf of leaves) {
                    let cur = leaf;
                    while (cur !== -1 && cur != null) {
                        candidateIds.add(cur);
                        const parent = tree.getNodeParentId(cur);
                        if (parent === cur) break;
                        cur = parent;
                    }
                }

                const propsAll = await new Promise((res, rej) =>
                    viewer.model.getBulkProperties([...candidateIds], null, res, rej)
                );
                const propsMap = new Map(propsAll.map((r) => [r.dbId, r.properties || []]));

                const pick = (propsArr, aliases) => {
                    const set = new Set(aliases.map(norm));
                    for (const p of propsArr || []) {
                        const name = norm(p.displayName || p.attributeName || p.name || '');
                        if (set.has(name)) return p.displayValue ?? p.value ?? '';
                    }
                    return '';
                };

                const pnAliases = ['part number', 'partnumber', 'numer części', 'numer czesci', 'pn', 'number'];
                const descAliases = ['description', 'opis', 'opis elementu', 'opis komponentu'];
                const matAliases = ['material', 'materiał', 'material name', 'nazwa materiału', 'nazwa materialu'];
                const isIso10642 = /^iso\s*10642\b/i;

                // znajdź pierwszy przodek z PN
                const findOccWithPn = (startId) => {
                    let cur = startId;
                    while (cur !== -1 && cur != null) {
                        const pn = pick(propsMap.get(cur) || [], pnAliases);
                        if (pn) return cur;
                        const parent = tree.getNodeParentId(cur);
                        if (parent === cur) break;
                        cur = parent;
                    }
                    return startId;
                };

                const countedOcc = new Set(); // zliczamy occurrence tylko raz
                const grouped = new Map(); // pn -> { pn, qty, desc, mat }

                for (const leaf of leaves) {
                    const occ = findOccWithPn(leaf);
                    if (countedOcc.has(occ)) continue;
                    countedOcc.add(occ);

                    const propsOcc = propsMap.get(occ) || [];
                    const propsLeaf = propsMap.get(leaf) || [];

                    let pn = pick(propsOcc, pnAliases);
                    let ds = pick(propsOcc, descAliases) || pick(propsLeaf, descAliases);
                    let mt = pick(propsLeaf, matAliases) || pick(propsOcc, matAliases);

                    if (!pn) {
                        // awaryjnie nazwa węzła
                        pn =
                            viewer.model?.getInstanceTree()?.getNodeName?.(occ) ||
                            viewer.model?.getInstanceTree()?.getNodeName?.(leaf) ||
                            `#${leaf}`;
                    }

                    if ((!mt || !String(mt).trim()) && !isIso10642.test(pn)) {
                        mt = 'Drewno (brzoza)';
                    }

                    const row = grouped.get(pn) || { pn, qty: 0, desc: '', mat: '' };
                    row.qty += 1; // liczymy wystąpienia zespołu/części, nie liście
                    if (!row.desc && ds) row.desc = ds;
                    if (!row.mat && mt) row.mat = mt;
                    grouped.set(pn, row);
                }

                const rows = Array.from(grouped.values())
                    .sort((a, b) => a.pn.localeCompare(b.pn, 'pl', { numeric: true, sensitivity: 'base' }))
                    .map((r, i) => ({ row: i + 1, pn: r.pn, qty: r.qty, desc: r.desc, mat: r.mat }));

                resolve(rows);
            });
        } catch (e) {
            reject(e);
        }
    });
}

// -------------------------
//  LICZENIE TOP-LEVEL ASM
// -------------------------
async function computeTopAssemblyCounts(viewer) {
    return new Promise((resolve) => {
        viewer.getObjectTree((tree) => {
            let rootId = tree.getRootId();

            // jeśli root jest "opakowany" (np. "Złożenie ×1"), zejdź o 1 poziom
            const tmpChildren = [];
            tree.enumNodeChildren(rootId, (cid) => tmpChildren.push(cid));
            if (tmpChildren.length === 1) {
                rootId = tmpChildren[0];
            }

            const tables = [];
            const benches = [];
            const chairs = [];

            tree.enumNodeChildren(rootId, (cid) => {
                const name = latinize(tree.getNodeName(cid) || '');
                // prefiksy/odmiany nazw
                if (name.includes('stol')) {
                    tables.push(cid);
                } else if (name.includes('lawka')) {
                    benches.push(cid);
                } else if (name.includes('fotel') || name.includes('krzeslo')) {
                    chairs.push(cid);
                }
            });

            resolve({ tables, benches, chairs });
        });
    });
}

export class ForgeView extends Component {
    constructor(props) {
        super(props);
        this.viewerDiv = React.createRef();
        this.viewer = null;
    }

    handleScriptLoad() {
        const options = repo.hasAccessToken() ? { accessToken: repo.getAccessToken() } : { env: 'Local' };

        Autodesk = window.Autodesk;

        const container = this.viewerDiv.current;
        this.viewer = new Autodesk.Viewing.GuiViewer3D(container);

        Autodesk.Viewing.Initializer(options, this.handleViewerInit.bind(this));
    }

    async handleViewerInit() {
        const errorCode = this.viewer.start();
        if (errorCode) return;

        // udostępnij viewer globalnie i powiadom, że działa
        window._forgeViewer = this.viewer;
        window.dispatchEvent(new CustomEvent('forge-viewer-ready', { detail: { viewer: this.viewer } }));

        const doSnapshot = async () => {
            try {
                // Płaska lista BOM do starego mechanizmu:
                const rows = await buildLeafBom(this.viewer);
                window._bomFromViewer = rows;
                window.dispatchEvent(new CustomEvent('bom-from-viewer-ready', { detail: { rows } }));

                // Nowe: liczenie liczby stołów/ławek/krzeseł
                const counts = await computeTopAssemblyCounts(this.viewer);
                window._asmCounts = counts; // { tables:number[], benches:number[], chairs:number[] }
                window.dispatchEvent(new CustomEvent('assembly-counts-ready', { detail: counts }));
            } catch (e) {
                // pominięte – spróbujemy przy kolejnym evencie
            }
        };

        // Po załadowaniu geometrii – snapshoty
        this.viewer.addEventListener(Autodesk.Viewing.GEOMETRY_LOADED_EVENT, doSnapshot);

        // załaduj model jeśli jest
        if (!this.props.activeProject.svf) return;

        Autodesk.Viewing.Document.load(
            this.getSvfUrl(),
            async (doc) => {
                const defaultModel = doc.getRoot().getDefaultGeometry();
                try {
                    await this.viewer.loadDocumentNode(doc, defaultModel);
                    // dodatkowa próba (gdyby GEOMETRY_LOADED już „mignęło”)
                    await doSnapshot();
                } catch (err) {
                    console.error('[ForgeView] Failed to load model:', err);
                }
            },
            (e) => console.warn('Document.load error', e)
        );
    }

    componentDidUpdate(prevProps) {
        if (Autodesk && this.props.activeProject.svf !== prevProps.activeProject.svf) {
            Autodesk.Viewing.Document.load(
                this.getSvfUrl(),
                async (doc) => {
                    const defaultModel = doc.getRoot().getDefaultGeometry();
                    try {
                        await this.viewer.loadDocumentNode(doc, defaultModel);

                        const rows = await buildLeafBom(this.viewer);
                        window._bomFromViewer = rows;
                        window.dispatchEvent(new CustomEvent('bom-from-viewer-ready', { detail: { rows } }));

                        const counts = await computeTopAssemblyCounts(this.viewer);
                        window._asmCounts = counts;
                        window.dispatchEvent(new CustomEvent('assembly-counts-ready', { detail: counts }));
                    } catch (err) {
                        console.error('[ForgeView] Failed to load model:', err);
                    }
                },
                (e) => console.warn('Document.load error', e)
            );
        }
    }

    componentWillUnmount() {
        if (this.viewer) {
            try {
                this.viewer.finish();
                Autodesk.Viewing.shutdown();
            } catch (err) {
                // celowo ignorujemy błąd przy zamykaniu viewer'a
            }
            this.viewer = null;
            delete window._forgeViewer;
        }
    }

    getSvfUrl() {
        return this.props.activeProject.svf + `/bubble.json`;
    }

    render() {
        return (
            <div className="modelContainer fullheight">
                <Message />
                <div className="viewer" id="AutodeskViewer">
                    <div ref={this.viewerDiv}></div>
                    <link rel="stylesheet" type="text/css" href={viewerCss} />
                    <Script url={viewerJs} onLoad={this.handleScriptLoad.bind(this)} />
                </div>
            </div>
        );
    }
}

/* istanbul ignore next */
export default connect((store) => ({ activeProject: getActiveProject(store) }))(ForgeView);
